import React, { Component } from 'react'
import HeaderLine from '../../components/headerLine/headerLine'
import DetayMainContainer from '../../components/detay/detayMainContainer'
import DetayContainer from '../../components/detay/detayContainer'
import { getCall } from '../../helpers/api/api'
import { getIdFromUrl } from '../../pages/helpers/getIdFromUrl'
import Dots from '../activityIndicators/dots'
var parse = require('html-react-parser');

const detayData = {
    bitkiCesitleriDetay: {
        endPoint: "/plantType/detay/",
        header: "Bitki Çeşitleri"
    },
    calismalarDetay: {
        endPoint: "/calismalarimiz/detay/",
        header: "Çalışmalar"
    },
    projelerDetay: {
        endPoint: "/projeler/detay/",
        header: "Projeler"
    },
    ekipDetay: {
        endPoint: "/ekipList/detay/",
        header: "Ekip"
    }
}

class DetayCreator extends Component {

    constructor(props) {
        super(props)
        this.state = {
            data: [],
            pageName: "",
            dataCame: false,
        }
        this.detays = []
    }

    async componentDidMount() {
        const id = getIdFromUrl(this.props.history.location.pathname, 3)
        const pageName = getIdFromUrl(this.props.history.location.pathname, 2)
        await this.setState({ pageName })

        try {
            const getData = await getCall(detayData[pageName].endPoint + id)
            await this.setState({ dataCame: true, data: getData.data })
        }
        catch (err) {
            console.log(err)
        }
    }

    renderDetay(d, data) {
        return <DetayContainer prop={d} val={data[d]} />
    }

    prepareRender(){
        this.state.data.map(async data => {
            for (let d in data) {
                if (d === "icerik" || d === "ozgecmis") {
                    let da = parse(data[d])
                    data[d] = da
                }
                else if (Array.isArray(data[d]) === true) {
                    let str = ""
                    for(let i = 0; i < data[d].length; i++){
                        if(i === data[d].length - 1){
                            str += data[d][i]
                        }else{
                            str += data[d][i]+ ", "
                        }
                    }
                    data[d] = str
                }
                this.detays.push(this.renderDetay(d, data))
            }
        })
    }

    render() {
        this.prepareRender()
        if (!this.state.dataCame) {
            return (
                <Dots />
            )
        }
        return (
            <React.Fragment>
                <HeaderLine header="Detay" />
                <DetayMainContainer>
                    <p className="main-paragraph">{detayData[this.state.pageName].header}</p>
                    {this.detays.map(d => {
                        return (
                            d
                        )
                    })}
                </DetayMainContainer>

            </React.Fragment>
        )
    }
}

export default DetayCreator